import { render, staticRenderFns } from "./setting-customerPortal.vue?vue&type=template&id=4cded717&scoped=true&"
import script from "./setting-customerPortal.vue?vue&type=script&lang=js&"
export * from "./setting-customerPortal.vue?vue&type=script&lang=js&"
import style0 from "./setting-customerPortal.vue?vue&type=style&index=0&id=4cded717&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cded717",
  null
  
)

export default component.exports